import React from 'react';
import Icon from '../icon/Icon';
import IconButton from '../iconButton/IconButton';
import CrossChunky from '../iconography/icons/CrossChunky';
import { useTheme } from '../theme-context';
import stylesAlert from './InlineAlert.module.scss';

export type InlineAlertType = 'neutral' | 'success' | 'warning' | 'error';

export interface InlineAlertProps {
    'data-testid'?: string;
    iconType?: JSX.Element;
    title?: string;
    description?: string;
    type?: InlineAlertType;
    closeHandler: () => void;
    showCloseButton?: boolean;
}

const InlineAlert = ({
    'data-testid': dataTestId,
    iconType,
    title,
    description,
    type,
    closeHandler,
    showCloseButton,
}: InlineAlertProps): React.ReactElement => {
    const { styles } = useTheme();

    let notificationClasses = '';

    let notificationIconClasses = '';

    switch (type) {
        case 'success':
            notificationClasses = 'eds-notification-bar--success';
            notificationIconClasses = 'eds-icon-button--success';
            break;
        case 'warning':
            notificationClasses = 'eds-notification-bar--warning';
            notificationIconClasses = 'eds-icon-button--warning';
            break;
        case 'error':
            notificationClasses = 'eds-notification-bar--error';
            notificationIconClasses = 'eds-icon-button--error';
            break;
        default:
            notificationClasses = 'eds-notification-bar--neutral';
            notificationIconClasses = 'eds-icon-button--neutral';
            break;
    }

    let fillIcon = styles.colors['grey-06'].color;

    if (type && ['error', 'success'].indexOf(type) >= 0) {
        fillIcon = styles.colors['brand-white'].color;
    }

    return (
        <div
            className={`eds-notification-bar--has-close eds-notification-bar ${notificationClasses} ${stylesAlert.alertContainer}`}
            data-testid={dataTestId}
        >
            {iconType && (
                <div className={stylesAlert.iconContainer}>
                    <Icon
                        type={iconType}
                        classes="eds-notification-bar__icon eds-l-pad-left-2 eds-l-pad-vert-1"
                    />
                </div>
            )}
            <div className={stylesAlert.textContainer}>
                <div className={stylesAlert.title}>
                    {title && <p>{title}</p>}
                </div>
                <div>{description && <p>{description}</p>}</div>
            </div>
            {showCloseButton ? (
                <div
                    className={`eds-notification-bar__close eds-l-pad-right-2 eds-l-pad-vert-1  ${stylesAlert.closeButton}`}
                >
                    <span
                        className={`eds-icon-button ${notificationIconClasses}`}
                        data-testid="close-button"
                    >
                        <IconButton
                            iconType={<CrossChunky fill={fillIcon} />}
                            onClick={closeHandler}
                            data-testid="close-icon-button"
                        />
                    </span>
                </div>
            ) : undefined}
        </div>
    );
};

export default InlineAlert;
